import * as BABYLON from "@babylonjs/core/Legacy/legacy";

import "@babylonjs/loaders/glTF";

import { config } from "./config.js";
import { KinematicObject } from "./kinematic.js";
import { GameScene } from "./scene.js";

const log = console.log.bind(console);

export class Player {
    private gameScene: GameScene;
    private scene: BABYLON.Scene;
    private camera: BABYLON.ArcRotateCamera;
    mesh: BABYLON.Mesh;

    // 用来检测碰撞的 mesh
    private intersectMeshH: number;
    public intersectMesh: BABYLON.Mesh;
    private targetPosition: BABYLON.Vector3;
    private position: BABYLON.Vector3;
    animations: BABYLON.Animation[];

    kinObj: KinematicObject;
    // controller: CharacterController

    constructor(gameScene: GameScene, camera: BABYLON.ArcRotateCamera) {
        this.gameScene = gameScene;
        this.scene = gameScene.bbScene;
        this.camera = camera;
        let h = 0.5;
        this.intersectMeshH = h;
        this.intersectMesh = BABYLON.MeshBuilder.CreateBox("player_box", {
            // size: 0.1,
            height: h,
            width: 0.2,
            depth: 0.2,
        });
        this.intersectMesh.position.y = h / 2 + config.groundHeight;

        const mat = new BABYLON.StandardMaterial("player_material", this.scene);
        mat.diffuseColor = BABYLON.Color3.Blue();
        mat.alpha = 0.0;
        this.intersectMesh.material = mat;

        let pos = this.intersectMesh.position;
        this.targetPosition = new BABYLON.Vector3(pos.x, pos.y, pos.z);

        // 让相机跟随角色  这样移动角色相机会始终跟着角色走
        this.camera.target = this.targetPosition;

        // 加载模型资源
        let self = this;
        this.gameScene.GetAsset().loadFileAsync("./assets/player.glb", (buf: ArrayBuffer) => {
            this.gameScene.GetAsset().loadMeshAsync(
                "",
                "",
                new DataView(buf),
                this.scene,
                (result: BABYLON.ISceneLoaderAsyncResult) => {
                    self.resetByMesh(result);
                },
                ".glb",
            );
        });
    }

    intersectsMesh(m: BABYLON.Mesh): boolean {
        return this.intersectMesh.intersectsMesh(m);
    }

    addInPlace(v: BABYLON.Vector3) {
        // this.mesh.position.addInPlace(v)
        // this.intersectMesh.position.addInPlace(v)
        // this.targetPosition.addInPlace(v)
    }

    update() {
        // log("---player update", this.position);
        // 人物和动画
        this.kinObj.update();

        // 镜头焦点对象
        this.targetPosition.x = this.kinObj.position.x;
        this.targetPosition.z = this.kinObj.position.z;

        // 金币碰撞用的矩形
        this.intersectMesh.setAbsolutePosition(this.kinObj.position);
        this.intersectMesh.position.y += this.intersectMeshH / 2;
    }

    pos2D(): BABYLON.Vector2 {
        return new BABYLON.Vector2(this.position.x, this.position.z);
    }

    setPosX(val: number) {
        this.position.x = val;
    }

    setPosZ(val: number) {
        this.position.z = val;
    }

    rotate(axis: BABYLON.Vector3, amount: number, space?: BABYLON.Space): BABYLON.TransformNode {
        return this.mesh.rotate(axis, amount, space);
    }

    resetByMesh(result: BABYLON.ISceneLoaderAsyncResult) {
        log("---resetByMesh");
        let self = this;
        let meshes = result.meshes;
        self.mesh = meshes[0] as BABYLON.Mesh;
        log("player mesh", self.mesh);

        // 放大
        self.mesh.scaling.scaleInPlace(3);

        // 设置位置
        self.mesh.setAbsolutePosition(new BABYLON.Vector3(0, config.groundHeight, 0));

        // 暴露位置
        self.position = self.mesh.position;

        window.meshes = meshes;
        result.animationGroups[0].stop();

        // animationGroups 里面存了模型的动画
        // 分别是 idle walk run jump
        // 用这样的方式转存到一个字典里
        var animationMap = {};
        for (let ag of result.animationGroups) {
            animationMap[ag.name] = ag;
        }

        self.mesh.ellipsoid = new BABYLON.Vector3(0.2, this.intersectMeshH, 0.2);
        self.mesh.ellipsoidOffset = new BABYLON.Vector3(0, this.intersectMeshH, 0);
        self.mesh.checkCollisions = true;

        // 动力对象
        this.kinObj = new KinematicObject(this.scene, this.mesh, animationMap, config.runSpeed, config.jumpSpeed);
        this.kinObj.run();

        // this.targetPosition = this.kinObj.position

        log("---resetByMesh", self.position);
    }

    setRunSpeed(speed: number) {
        this.kinObj.setRunSpeed(speed);
    }

    getRunSpeed(): number {
        return this.kinObj.getRunSpeed();
    }

    jump() {
        this.kinObj.jump();
    }

    moveLeftToX(x: number) {
        if (this.kinObj.isMovingHori()) {
            return;
        }
        this.kinObj.moveLeftToX(x);
    }

    moveRightToX(x: number) {
        if (this.kinObj.isMovingHori()) {
            return;
        }
        this.kinObj.moveRightToX(x);
    }

    moveLeftToZ(z: number) {
        if (this.kinObj.isMovingHori()) {
            return;
        }
        this.kinObj.moveLeftToZ(z);
    }

    moveRightToZ(z: number) {
        if (this.kinObj.isMovingHori()) {
            return;
        }
        this.kinObj.moveRightToZ(z);
    }
}
